import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS, ReactTable } from "components";
import { isPercentageField } from "modules/DealerReports/util/helper";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";

type ReportRow = {
  [key: string]: any;
};

type LocationReportTableProps = {
  data: Record<string, string>[];
};

const formatTableCell = (key: string, value: any, t: TFunction): React.ReactNode => {
  if (value === null || value === undefined) return "0";

  if (typeof value === "object" && value !== null && "value" in value) {
    if ("percent" in value) {
      return (
        <>
          {value.value} <span style={{ color: value.color ? value.color : "inherit" }}>({value.percent}%)</span>
        </>
      );
    }

    return value.value;
  }

  if (isPercentageField(key)) return `${value}%`;
  if (typeof value === "number" && value.toString().includes(".")) return value.toString().includes(".");
  return key.includes("date") ? formatDate(value, DATE_FORMATS_FNS.dateMonthYear) : t(value) || value;
};

const columnHelper = createColumnHelper<ReportRow>();

export const LocationReportsTable = ({ data }: LocationReportTableProps) => {
  const { t } = useTranslation();

  const columns = Object.keys(data.at(0) ?? {})
    .filter(key => key !== "__typename")
    .map(key =>
      columnHelper.accessor(key, {
        id: key,
        header: () => <strong>{t(`v8_${key}`) || key}</strong>,
        cell: info => formatTableCell(key, info.getValue(), t),
        minSize: 135
      })
    );

  return (
    <div className="location-reports-table-container">
      <div className="location-reports-table-wrapper">
        <ReactTable data={data} columns={columns} />
      </div>
    </div>
  );
};
